import { viandas2Get } from "../../../common/service/viandas2Client";

// Usuarios activos (no bloqueados) que no pidieron ninguna vianda en el rango.
// GET /api/viandas2/rrhh/pedidos/faltantes?desde=&hasta=&id_sucursal=
export const getUsuariosSinPedir = (filtros = {}) =>
  viandas2Get("/rrhh/pedidos/faltantes", filtros);
